import { syncRender } from 'globalCommon/services/syncRender';
import { getDesktopClientDownloadLink } from 'globalCommon/utils/index';
import Toast from 'globalCommon/utils/toast';
import commonPageService from 'pcCommon/services/commonPageService';
import './style.css';

function init() {
    commonPageService({ renderAfter: syncRender });
    initCopy();
}

async function initCopy() {
    const downloadLink = await getDesktopClientDownloadLink();
    const downloadClientBtn = document.getElementById('download-desktop-client-btn');
    downloadClientBtn?.setAttribute('href', downloadLink);

    const copyBtn = document.getElementById('copy-download-link');

    if (copyBtn) {
        const clipboard = new ClipboardJS(copyBtn, {
            text: function () {
                return downloadLink;
            },
        });
        clipboard.on('success', function () {
            Toast('Copiado com sucesso');
        });
    }
}

init();
